import { render, staticRenderFns } from "./exam-details.vue?vue&type=template&id=8cf3e2da&scoped=true"
import script from "./exam-details.vue?vue&type=script&lang=js"
export * from "./exam-details.vue?vue&type=script&lang=js"
import style0 from "./exam-details.vue?vue&type=style&index=0&id=8cf3e2da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf3e2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf3e2da')) {
      api.createRecord('8cf3e2da', component.options)
    } else {
      api.reload('8cf3e2da', component.options)
    }
    module.hot.accept("./exam-details.vue?vue&type=template&id=8cf3e2da&scoped=true", function () {
      api.rerender('8cf3e2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/exam-details.vue"
export default component.exports